<template>
  <div id="app" :class="{isNewVersion}">
    <feed-back v-if="CUX_INT_HELP.length > 0"></feed-back>
    <router-view/>
  </div>
</template>
<script>
import FeedBack from '@/components/feedBack';
import { mapGetters } from 'vuex';

export default {
    components: {
        FeedBack,
    },
    computed: {
        ...mapGetters(['isNewVersion']),
    },
    data() {
        return {
            CUX_INT_HELP: [],
        };
    },
    mounted() {
        /* 云打印模板 */
        this.getDictByCode('CUX_PRINT_FORMWORK', (data) => {
            this.$store.commit('SET_CUX_PRINT_FORMWORK', data);
        });
        /* 时区转换 */
        this.getDictByCode('INT_TIME_ZONE', (data) => {
            this.$store.commit('SET_INT_TIME_ZONE', data);
        });
        /* 是否启用自助报障 */
        this.getDictByCode('CUX_INT_HELP');
        /* qms接口地址切换 */
        this.getDictByCode('CUX_INT_QMS_ADDRESS', (data) => {
            this.$store.commit('SET_CUX_INT_QMS_ADDRESS', data);
        });
        /* 是否启用新表格组件 */
        this.getDictByCode('INT_NEW_SWITCH', (data) => {
            this.$store.commit('SET_NEW_SWITCH', data);
        });
    },
};
</script>
<style lang="less" scoped>
#app {
  height: 100%;
}
</style>
